import {
  DocumentSecurityLabelCodes,
  QuiltedHealthCodeSystems,
  UploadedDocumentSourceCodes,
} from "@/fhir/enums/quilted-health";
import { AllowedFileTypes } from "@/types/uploads";

export const VISIBLE_TO_CLIENT = {
  system: QuiltedHealthCodeSystems.DocumentSecurityLabel,
  code: DocumentSecurityLabelCodes.VisibleToClient,
  display: "Visible to Client",
};

export const NOT_VISIBLE_TO_CLIENT = {
  system: QuiltedHealthCodeSystems.DocumentSecurityLabel,
  code: DocumentSecurityLabelCodes.Restricted,
  display: "Restricted",
};

/**
 * `DocumentReference.category` that keeps a file away from clients: the patient access policy
 * excludes it from the client's reads, so a practice-only upload always carries it.
 */
export const PRACTICE_ONLY_CATEGORY_CODING = {
  system: QuiltedHealthCodeSystems.UploadedDocumentSource,
  code: UploadedDocumentSourceCodes.BillingAttachment,
  display: "Billing Attachment",
};

export enum FileDrawerType {
  Upload = "upload",
}

export enum FileUploadAction {
  Create = "create",
  Update = "update",
}

export interface UploadedFileData {
  id: string | undefined;
  name: string;
  type: string;
  description: string;
  dateAdded: string;
  addedBy: string;
  isVisibleToClient: boolean;
  url: string | undefined;
  contentType: AllowedFileTypes;
  lastUpdated: string | undefined;
}
